class MapReadySetterCtrl {

    constructor($scope, storeServ) {
        this.$scope = $scope;
        this.storeServ = storeServ;

        this.addMarkerClustererClusteringendListener();

        this.addComponentDestroyListener();
    }

    /**
     *  Init.
     */

    addMarkerClustererClusteringendListener() {
        this.clusteringEndListener = this.markerClusterer.addListener('clusteringend', this.onClusteringEnd.bind(this));
    }

    addComponentDestroyListener() {
        this.$scope.$on('$destroy', this.onDestroyComponent.bind(this));
    }

    /**
     *  Listeners.
     */

    onClusteringEnd() {
        let prev = this.mapReady;

        this.mapReady = true;

        if (prev === this.mapReady) {
            this.storeServ.dispatch({
                type: 'SET_MAP_READY',
                mapReady: true
            });

            this.clusteringEndListener.remove();
        }
    }

    onDestroyComponent() {
        this.clusteringEndListener.remove();
        
        this.storeServ.getState().mapReady && this.storeServ.dispatch({
            type: 'SET_MAP_READY',
            mapReady: false
        });
    }
}

MapReadySetterCtrl.$inject = ['$scope', 'storeServ'];

var mapReadySetterComponent = function() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        controller: MapReadySetterCtrl,
        bindToController: {
            markerClusterer: '='
        }
    };
};

export default mapReadySetterComponent;
